import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DatatableCompatDirective } from 'src/app/shared/datatables-compat/datatable-compat.module';
import { Config } from "datatables.net";
import { HistorialDCambios } from "src/app/clientes/models/historialDeCambios";
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { Constantes } from "src/app/utilerias/constantes/constantes";
import { Msg } from "src/app/utilerias/mensajes/Msg";

// Angular core y formularios
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Angular Material
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // ⬅ Necesario para que funcione el datepicker con fechas nativas

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

// DataTables para Angular
import { DatatableCompatModule } from 'src/app/shared/datatables-compat/datatable-compat.module';

@Component({
    selector: 'app-consulta-historial-cambios',
    templateUrl: './consulta-historial-cambios.component.html',
    styleUrls: ['./consulta-historial-cambios.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgxMatSelectSearchModule,
        DatatableCompatModule
    ]
})

export class ConsultaHistorialCambiosComponent implements OnInit {
    @ViewChild('tblCambios') dtElement: DatatableCompatDirective;
    tblCambiosPaginacion: Config = {};
    listHistorial: Array<HistorialDCambios>;
    idProyecto: number;
    consultaObject = new ConsultaList<HistorialDCambios>();

    constructor(public dialogRef: MatDialogRef<ConsultaHistorialCambiosComponent>, private modalDialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any, private service: ProyectosService, private msg: Msg) { }


    ngOnInit(): void {
        this.idProyecto = this.data;
        this.consultaPaginacion();

    }
    consultaPaginacion() {
        this.consultaObject.regInicial = Constantes.CERO;
        this.consultaObject.regXPagina = Constantes.CINCO;
        this.tblCambiosPaginacion = {
            pageLength: 10,
            language: {
                zeroRecords: " ",
            },
            serverSide: true,
            ajax: (dataTablesParameters: any, callback) => {
                this.consultaObject.regInicial = dataTablesParameters.start;
                this.consultaObject.regXPagina = dataTablesParameters.length;
                this.consultaObject.bean = new HistorialDCambios();
                this.consultaObject.bean.id_tipo = this.data.id;
                this.consultaObject.sort = 'id';
                this.consultaObject.param4 = Constantes.UNO;

                this.service.consultaHistoCambiosPaginacion(this.consultaObject).subscribe(res => {
                    if (res != null && res.list.length > 0) {
                        this.listHistorial = res.list;
                        callback({
                            recordsTotal: res.pTotalItems,
                            recordsFiltered: res.pTotalItems,
                            data: []
                        });
                    } else {
                        this.msg.warningCall("Sin registros para mostrar", null, null);
                    }
                });
            }
        }
    }

    closeModal() {
        this.dialogRef.close();
    }



}